import { render, staticRenderFns } from "./helpcenter.vue?vue&type=template&id=22e13814&"
import script from "./helpcenter.vue?vue&type=script&lang=ts&"
export * from "./helpcenter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./helpcenter.vue?vue&type=custom&index=0&blockType=route"
if (typeof block0 === 'function') block0(component)

export default component.exports